/**
 * A button that opens the article's reference as a QR code.
 *
 * The code encodes the reference and nothing else: it is what a warehouse
 * scanner or a phone reads back into the search box, so it carries no URL and
 * no tenant that a printed label would then have to keep true.
 */

import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { useTranslation } from "react-i18next";
import { Button, Dialog } from "@hardauto/core-ui";

import { NAMESPACE } from "../../i18n";

export function QrCodeButton({ reference }: { reference: string }) {
  const { t } = useTranslation(NAMESPACE);
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        size="sm"
        aria-label={`${t("consultation.qr.button")} ${reference}`}
        onClick={() => setOpen(true)}
      >
        {t("consultation.qr.button")}
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        title={t("consultation.qr.title")}
        description={t("consultation.qr.description")}
        closeLabel={t("consultation.qr.close")}
      >
        <div className="hardauto-qr">
          {/* White on black would not scan: the code keeps its own light ground. */}
          <QRCodeSVG
            value={reference}
            size={224}
            marginSize={4}
            bgColor="#ffffff"
            fgColor="#000000"
            title={t("consultation.qr.label", { reference })}
          />
          <code className="hardauto-qr__reference">{reference}</code>
        </div>
      </Dialog>
    </>
  );
}
